import React from "react";
import { Field } from "redux-form";
import { Action } from "typescript-fsa";
import { useIntl } from "react-intl";
import { InjectedFormProps } from "redux-form";
import { RouteComponentProps } from "react-router-dom";

import { AsyncForm } from "@api/components/AsyncForm";
import { FormInput } from "@ui/Form/FormInput";
import { LoginDetails } from "../../models";
import { messages } from "../../messages";

export interface LoginStateProps {
    authenticated: boolean;
}

export interface LoginDispatchProps {
    login: (credentials: LoginDetails) => Action<any>;
}

export type Props = LoginStateProps & LoginDispatchProps & RouteComponentProps<any> &
    InjectedFormProps<LoginDetails, LoginStateProps & LoginDispatchProps>;

export const Login = ({ authenticated, handleSubmit, history, login, error }: Props) => {
    const { formatMessage } = useIntl();
    if (authenticated) {
        history.push("/");
    }

    return (
        <div className="login-form">
            <AsyncForm submitText={formatMessage(messages.authLoginLogin)}
                actionCreator={login}
                handleSubmit={handleSubmit}
                error={error}>
                <Field
                    name="email"
                    type="email"
                    id="login-email"
                    component={FormInput}
                    showLabel={false}
                    label={formatMessage(messages.authLoginEmail)}
                    placeholder={formatMessage(messages.authLoginEmail)} />
                <Field
                    name="password"
                    type="password"
                    id="login-password"
                    showLabel={false}
                    component={FormInput}
                    label={formatMessage(messages.authLoginPassword)}
                    placeholder={formatMessage(messages.authLoginPassword)} />
            </AsyncForm>
        </div>
    );
};
